import React, { useState, useEffect, Fragment } from "react";
import { useHistory, useLocation } from "react-router";
import { useSelector } from "react-redux";
import _ from "lodash";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import ArticleCard from "./components/ArticleCard";
import AddArticleModal from "./components/AddArticleModal";
import EditArticleModal from "./components/EditArticleModal";
import "./index.css";

const SuperArticles = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [articles, setArticles] = useState([]);
  const [articleEditing, setArticleEditing] = useState(null);
  const myRole = useSelector((state) => state.myRole);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          console.log("brand_data", brand_data);
          setBrandData(brand_data);
          const { parent } = brand_data;
          Firebase.getArticlesByBrand(brand_data.name, (articles) => {
            const clone_articles = _.cloneDeep(articles);
            if (parent) {
              // I am inside sub brand and wanna get parent articles
              Firebase.getBrandDataByID(parent, (parentBrand_Data) => {
                const parentBrandName = parentBrand_Data.name;
                Firebase.getArticlesByBrand(parentBrandName, (res) => {
                  setLoading(false);
                  const parentArticles = res.filter((a) => a.postToSub);
                  setArticles(
                    [...clone_articles, ...parentArticles].sort(
                      (a, b) => a.time - b.time
                    )
                  );
                });
              });
            } else {
              // I am inside normal brand and wanna get articles
              setLoading(false);
              if (myRole === "isUmbrella" && brand_data.umbrella) {
                const articles = clone_articles.filter(
                  (item) => item.postToSub
                );
                setArticles(articles.sort((a, b) => a.time - b.time));
              } else
                setArticles(clone_articles.sort((a, b) => a.time - b.time));
            }
          });
        } else {
          history.push("/");
        }
        setLoading(false);
      });
    }
  }, [location]);

  const renderContent = () => {
    return (
      <div className="articles-content">
        <div className="article-items">
          {articles.map((article) => (
            <Fragment key={article.id}>
              <ArticleCard
                content={article}
                brandName={brand_data.name}
                id={article.id}
                onEdit={() => handleClickEdit(article)}
                onShare={() => handleClickSharing(article.id)}
              />
            </Fragment>
          ))}
          <button
            className="btn-secondary article-item add-article-btn btn-brand-hex"
            style={{
              backgroundColor: "white",
              color: "black",
              "--hover-text-color": brand_data.white ? "white" : "black",
              "--hover-color": brand_data.hex,
            }}
            data-toggle="modal"
            data-target="#add_article_modal"
          >
            <p
              style={{
                fontSize: "65px",
                lineHeight: "65px",
              }}
            >
              +
            </p>
            <p className="article-item-text">Add a new article</p>
          </button>
        </div>
      </div>
    );
  };
  const handleClickEdit = (article) => {
    setArticleEditing(article);
  };
  const handleClickSharing = (articleId) => {
    document.getElementById("notify").click();
    let brandname = brand_data.name.replace(/\s/g, "");
    let value =
      "https://ecosystem.club/" + brandname + "?articleId=" + articleId;
    navigator.clipboard.writeText(value);
  };
  const handleClickAdd = (article) => {
    article.username = username;
    article.uid = localStorage.getItem("uid");
    article.from_admin = true;
    article.time = new Date().getTime();
    if (myRole === "isUmbrella" && brand_data.umbrella) {
      article.postToSub = true;
    }
    Firebase.addArticle(article, brand_data.name);
  };
  const handleClickUpdate = (article) => {
    article.time = new Date().getTime();
    Firebase.updateArticle(brand_data.name, article.id, article);
  };
  return (
    <div id="page-container" className="articles-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {renderContent()}
        <AddArticleModal onAdd={handleClickAdd} brand={brand_data} />
        <EditArticleModal
          initial={articleEditing}
          onUpdate={handleClickUpdate}
          brand={brand_data}
        />
      </main>
    </div>
  );
};

export default SuperArticles;



// WEBPACK FOOTER //
// ./src/screens/SuperArticles/index.js